import { useParams } from 'react-router-dom';
import { useGetEmojisQuery } from '@/features/settings/api';
import { useMemo } from 'react';

export function useCustomEmojis() {
  const { householdId } = useParams();

  const { data: emojisData, isLoading: isLoadingEmojis } = useGetEmojisQuery({ householdId }, { skip: !householdId });

  const customEmojis = useMemo(() => {
    return [{
      id: 'custom',
      name: 'Custom',      
      emojis: emojisData?.data?.map(emoji => ({
        id: emoji.name.toLowerCase(),
        name: emoji.name,
        keywords: [emoji.name.toLowerCase()],
        skins: [{ src: emoji.url }]
      }))
    }]
  }, [emojisData]);

  return { customEmojis, isLoading: isLoadingEmojis };
}
